// Scripting for sliders or carousels (Baytek gutenblocks plugin includes a slider block that uses slick slider)
(function($){


	// Default Slider
	infinite = $('.default-slider > .wp-block-group__inner-container > *').length > 4;

	var numSlick = 0;
	$('.default-slider > .wp-block-group__inner-container').each( function() {
	  numSlick++;
	  $(this).addClass( 'default-slider-' + numSlick ).slick({
		arrows: true,
		appendArrows: '.slider-arrows-' + numSlick,
		dots: false,
		slidesToScroll: 1,
		slidesToShow: 4,
		draggable: true,
		prevArrow: '<a class="button slick-arrow slick-prev" aria-label="Previous"><i class="far fa-angle-left"></i></a>',
		nextArrow: '<a class="button slick-arrow slick-next" aria-label="Next"><i class="far fa-angle-right"></i></a>',
		//infinite: infinite,
		variableWidth: true,
		responsive: [{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
			}
		}]
	  });
	});


	
	// Testimonial Sliders
	$('.testimonial-slider > .wp-block-group__inner-container').slick({
		arrows: true,
		dots: false,
		slidesToScroll: 1,
		slidesToShow: 1,
		infinite: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
		prevArrow: '<div class="slick-arrow wp-block-buttons arrow top-arrow left-arrow"><div class="wp-block-button"><span class="wp-block-button__link"></span></div></div>',
		nextArrow: '<div class="slick-arrow wp-block-buttons arrow top-arrow right-arrow"><div class="wp-block-button"><span class="wp-block-button__link"></span></div></div>',
	});


	// Home Services Slider (also seen on Team Members)
	let infinite = $('.services-slides > .wp-block-group__inner-container > *').length > 4;

	$('.services-slides > .wp-block-group__inner-container').slick({
		arrows: true,
		appendArrows: '.services-slider-arrows',
		dots: false,
		slidesToScroll: 1,
		slidesToShow: 2,
		infinite: infinite,
		draggable: true,
		variableWidth: true,
		prevArrow: '<a class="button slick-arrow slick-prev" aria-label="Previous"><i class="far fa-angle-left"></i></a>',
		nextArrow: '<a class="button slick-arrow slick-next" aria-label="Next"><i class="far fa-angle-right"></i></a>',
	});


	// Awards Slider
	infinite = $('.awards-slider > .wp-block-group__inner-container > .wp-block-gallery > *').length > 5;

	var numSlick = 0;
	$('.awards-slider > .wp-block-group__inner-container > .wp-block-gallery').each( function() {
	  numSlick++;
	  $(this).addClass( 'awards-slider-' + numSlick ).slick({
		arrows: true,
		appendArrows: '.awards-slider-arrows-' + numSlick,
		dots: false,
		slidesToScroll: 1,
		slidesToShow: 5,
		draggable: true,
		prevArrow: '<a class="button slick-arrow slick-prev" aria-label="Previous"><i class="far fa-angle-left"></i></a>',
		nextArrow: '<a class="button slick-arrow slick-next" aria-label="Next"><i class="far fa-angle-right"></i></a>',
		infinite: infinite,
		responsive: [{
			breakpoint: 980,
			settings: {
				slidesToShow: 3,
			}
		},{
			breakpoint: 480,
			settings: {
				slidesToShow: 2,
			}
		}]
	  });
	});



	// Related Resources Slider
    infinite = $('.related-resources-slider > .wp-block-group__inner-container > *').length > 4;

    $('.related-resources-slider > .wp-block-group__inner-container').slick({
        arrows: true,
        appendArrows: '.related-resource-slider-arrows',
        dots: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: infinite,
        draggable: true,
        variableWidth: true,
        prevArrow: '<a class="button slick-arrow slick-prev" aria-label="Previous"><i class="far fa-angle-left"></i></a>',
        nextArrow: '<a class="button slick-arrow slick-next" aria-label="Next"><i class="far fa-angle-right"></i></a>',
    });


	/** Historical Occurances slider */

	var options = {
		arrows: true,
		appendArrows: '.historical-slider-arrows',
		dots: false,
		slidesToScroll: 1,
		slidesToShow: 4,
		infinite: false,
		draggable: true,
		adaptiveHeight: true,
		prevArrow: '<a class="button slick-arrow slick-prev" aria-label="Previous"><i class="far fa-angle-left"></i></a>',
		nextArrow: '<a class="button slick-arrow slick-next" aria-label="Next"><i class="far fa-angle-right"></i></a>',
		responsive: [{
			breakpoint: 980,
			settings: {
				slidesToShow: 3,
			}
		},{
			breakpoint: 480,
			settings: {
				slidesToShow: 2,
			}
		}]
	};


	// my slick slider as constant object
	const mySlider = $('.infographic-wrapper').on('init', function(slick) {

	  // on init run our multi slide adaptive height function
	  multiSlideAdaptiveHeight(this);

	}).on('beforeChange', function(slick, currentSlide, nextSlide) {

	  // on beforeChange run our multi slide adaptive height function
	  multiSlideAdaptiveHeight(this);

	}).slick(options);


	// our multi slide adaptive height function passing slider object
	function multiSlideAdaptiveHeight(slider) {

	  // set our vars
	  let activeSlides = [];
	  let tallestSlide = 0;

	  // very short delay in order for us get the correct active slides
	  setTimeout(function() {

	    // loop through each active slide for our current slider
	    $('.slick-track .slick-active', slider).each(function(item) {

	      // add current active slide height to our active slides array
	      activeSlides[item] = $(this).outerHeight();

	    });

	    // for each of the active slides heights
	    activeSlides.forEach(function(item) {

	      // if current active slide height is greater than tallest slide height
	      if (item > tallestSlide) {

	        // override tallest slide height to current active slide height
	        tallestSlide = item;

	      }

	    });

	    // set the current slider slick list height to current active tallest slide height
	    $('.slick-list', slider).height(tallestSlide);

	  }, 10);

	}


	// when window is resized
	$(window).on('resize', function() {

	  // run our multi slide adaptive height function incase current slider active slides change height responsively
	  multiSlideAdaptiveHeight(mySlider);

	});
})(jQuery);